import { QueryObserverResult, useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { getCities } from '../api/cities';
import { BaseQueryParams } from '../common/models/base-query-params';
import { CityResponse } from '../common/models/city';
import { HttpException } from '../common/models/httpException';
import { Paginated } from '../common/models/paginated';

export const CK_CITIES = 'cities';

export const useCities = (
  params: BaseQueryParams & { countryId?: string } = { page: 1, limit: 0 },
  enabled = true,
): QueryObserverResult<Paginated<CityResponse>, AxiosError<HttpException>> =>
  useQuery(
    [CK_CITIES, { page: params.page, limit: params.limit, countryId: params.countryId }],
    () => getCities(params),
    {
      keepPreviousData: true,
      enabled,
    },
  );
